module.exports = __webpack_public_path__ + "img/square-gold-blank-small.aeaa4cc1.png";